import { useState } from "react";
import { toHTML } from "../utils/ComponentUtil";
import CustomRadioInput from "../utils/CustomRadioInput";
import CustomTextField from "../utils/CustomTextField";


function NewProofReadingContent({ item, editContent, onSave }) {
    const [value, setValue] = useState(item.content);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleChange = (e) => { setValue(e.target.value); };
    return (
        <>
            <h3>{item.title}</h3>
            <div>{toHTML(item.content)}</div>
            <div className="feedback-wrp">
                {!isEditMode ?
                    <div className="edit-content-btn-wrp hbw-button-wrp">
                        <div className="edit-content-btn hbw-button" onClick={() => { setIsEditMode(true); }}>Start Reading</div>
                    </div> : <>
                        <div className="fb-title">Send your feedback</div>
                        <div className="fb-subtitle">Select the feedbacks which you have to give for this proof reading content.</div>
                        <CustomRadioInput options={item?.feedbackOptions || []} />
                        <CustomTextField name='other-feedback' label="Other Options" placeholder="Type your other options" onChange={() => {}} />
                        <div className="edit-content-btn-wrp hbw-button-wrp">
                            <div className="edit-content-btn hbw-button" onClick={() => { setIsEditMode(true); }}>Submit Feedback</div>
                        </div>
                    </>}
            </div>
        </>
    );
};
export default NewProofReadingContent;
